import { Box, Button, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState, useContext } from "react";
// import ReactExport from "react-data-export";
import { AppDataContext } from "../../../common/appContext";
import { exportPlayerProfileDataToExcel } from "../../../common/exportToExcelFunctions/PlayerProfileExport";
import { exportPlayerCareerStatsToExcel } from "../../../common/exportToExcelFunctions/PlayerCareerStatsExport";
import { exportAnthrosSummaryDataToExcel } from "../../../common/exportToExcelFunctions/AnthrosExport";
import { exportStrengthAndAgilityDataToExcel } from "./../../../common/exportToExcelFunctions/StrengthAndAgilityExport";
import { exportShootingDrillsDataToExcel } from "../../../common/exportToExcelFunctions/ShootingDrillsExport";
import { exportPlayerProfileDetails } from "../../../common/exportToExcelFunctions/ExportPlayerProfileDetails";
import { exportPlayerCareerStatsDetails } from "../../../common/exportToExcelFunctions/ExportPlayerCareerStatsDetails";
import { exportPlayerProfileAnthroDetails } from "../../../common/exportToExcelFunctions/ExportPlayerProfileAnthroDetails";
import { exportPlayerProfileStrengthAndAgilityDetails } from "../../../common/exportToExcelFunctions/ExportPlayerProfileStrengthAndAgilityDetails";
import { exportPlayerProfileShootingDrills } from "../../../common/exportToExcelFunctions/ExportPlayerProfileShootingDrills";
import { exportDataToExcel } from "../../../sharedComponents/CustomExportToExcel";

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const useStyles = makeStyles((theme) => ({
  exportToExcel: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
}));

export default function ViewPlayerProfileExport({
  playerData,
  playerCareerStatsData,
  anthrosSummaryData,
  strengthAndAgilityData,
  shootingDrillsData,
}) {
  const classes = useStyles();

  let {
    shootingDrillsOverallSummary,
    spotUpDrillData,
    threePointStarDrillData,
    midRangeStarDrillData,
    sideMidSideDrillData,
    midSideMidDrillData,
    offTheDribbleShootingData,
    freeThrowsData,
  } = shootingDrillsData;

  const {
    lengthUnits,
    weightUnits,
    getWeightUnitValue,
    getLengthUnitValue,
    getLengthUnitLabelType,
    getWeightUnitLabelType,
    getHandDimensionsUnitValue,
    getHandDimensionsUnitLabelType,
    selectedEvent,
  } = useContext(AppDataContext);

  const [excelClick, setExcelClick] = useState(false);

  const blankDataset = [
    {
      columns: [
        {
          title: "No Records Found",
          width: { wpx: 500 },
        },
      ],
      data: [""].map((record) => {
        return [
          {
            value: record,
          },
        ];
      }),
    },
  ];

  const [sheetData, setSheetData] = useState([
    {
      sheetName: "sheet1",
      dataset: blankDataset,
      key: 0,
    },
    {
      sheetName: "sheet2",
      dataset: blankDataset,
      key: 1,
    },
    {
      sheetName: "sheet3",
      dataset: blankDataset,
      key: 2,
    },
    {
      sheetName: "sheet4",
      dataset: blankDataset,
      key: 3,
    },
    {
      sheetName: "sheet5",
      dataset: blankDataset,
      key: 4,
    },
  ]);

  useEffect(() => {
    if (excelClick) {
      document.getElementById("view-player-profile-excel-export").click();
      setExcelClick(false);
    }
  }, [excelClick]);

  const preProcessGridData = (gridResponseData, gridNumber) => {
    let labels,
      regions = {};
    if (gridNumber === 1) {
      labels = [
        "Spot Up Shooting",
        "3-Point Star",
        "Mid Range Star",
        "Side Mid Side",
        "Mid Side Mid",
        "Off The Dribble",
        "Free Throws",
      ];
    }
    if (gridNumber === 2) {
      labels = [
        "Top Key",
        "Right Elbow",
        "Right Corner",
        "Left Corner",
        "Left Elbow",
      ];
      regions = {
        TopKey: labels[0],
        RightElbow: labels[1],
        RightCorner: labels[2],
        LeftCorner: labels[3],
        LeftElbow: labels[4],
      };
    }
    if (gridNumber === 3 || gridNumber === 4) {
      labels = [
        "Top Key",
        "Right Elbow",
        "Right Corner",
        "Left Corner",
        "Left Elbow",
      ];
      regions = {
        TopKey: labels[0],
        RightWing: labels[1],
        RightCorner: labels[2],
        LeftCorner: labels[3],
        LeftWing: labels[4],
      };
    }
    if (gridNumber === 5 || gridNumber === 6) {
      labels = [
        "Center Half to Top Key",
        "Right Side Line to Right Wing",
        "Left Side Line to Left Wing",
      ];
      regions = {
        CenterHalfToTopKey: labels[0],
        RightSidelineToRightWing: labels[1],
        LeftSidelineToLeftWing: labels[2],
      };
    }
    if (gridNumber === 7) {
      labels = [
        "Top Key",
        "Right Wing",
        "Right Dribble (Overall)",
        "Left Dribble (Overall)",
        "Left Wing",
      ];
      regions = {
        TopKey: labels[0],
        RightWing: labels[1],
        "Right Dribble (Overall)": "Right Dribble (Overall)",
        "Left Dribble (Overall)": "Left Dribble (Overall)",
        LeftWing: labels[4],
      };
    }
    if (gridNumber === 8) {
      labels = ["Free Throw Line"];
      regions = {
        FreeThrowline: labels[0],
      };
    }
    let finalGridData = [],
      apiData = [],
      regionLabel = Object.keys(regions).length ? { ...regions } : "";
    gridResponseData.forEach((elem, i) => {
      if (
        labels.includes(
          regionLabel !== "" ? regionLabel[elem.region] : elem.region
        )
      ) {
        apiData.push(
          regionLabel !== "" ? regionLabel[elem.region] : elem.region
        );
        finalGridData.push({
          region: regionLabel !== "" ? regionLabel[elem.region] : elem.region,
          result: `${elem.noOfMade} / ${elem.maxCount}`,
          percentage: elem.percentage,
        });
      }
    });
    const difference = labels.filter((x) => !apiData.includes(x));
    difference.forEach((elem, i) => {
      finalGridData.push({
        region: elem,
        result: "--",
        percentage: "--",
      });
    });
    return finalGridData;
  };

  //#NEW EXCEL EXPORT FUNCTIONALITY
  const exportToExcelHandler = async () => {
    const processedGridData = getProcessedShootingDrillsData();

    const sheetsData = [
      {
        sheetName: "Basic Stats",
        tables: exportPlayerProfileDetails(
          playerData,
          lengthUnits,
          weightUnits,
          getWeightUnitValue,
          getLengthUnitValue,
          getWeightUnitLabelType
        ),
      },
      {
        sheetName: "Career Basic Stats",
        tables: exportPlayerCareerStatsDetails(playerCareerStatsData),
      },
      {
        sheetName: "Anthropometry",
        tables: exportPlayerProfileAnthroDetails(
          anthrosSummaryData,
          getLengthUnitLabelType,
          getLengthUnitValue,
          getWeightUnitLabelType,
          getWeightUnitValue,
          lengthUnits,
          weightUnits,
          getHandDimensionsUnitValue,
          getHandDimensionsUnitLabelType,
          selectedEvent
        ),
      },
      {
        sheetName: "Strength & Agility",
        tables: exportPlayerProfileStrengthAndAgilityDetails(
          strengthAndAgilityData,
          lengthUnits,
          getHandDimensionsUnitValue,
          getHandDimensionsUnitLabelType,
          selectedEvent
        ),
      },
      {
        sheetName: "Shooting Drills",
        tables: exportPlayerProfileShootingDrills(processedGridData),
      },
    ];

    try {
      await exportDataToExcel(sheetsData, "View Player Profile");
    } catch (error) {
      console.log("error", error);
    }
  };

  const getProcessedShootingDrillsData = () => {
    // Shooting Drills Data
    let gridData1 = preProcessGridData(shootingDrillsOverallSummary, 1);
    let gridData2 = preProcessGridData(spotUpDrillData, 2);
    let gridData3 = preProcessGridData(threePointStarDrillData, 3);
    let gridData4 = preProcessGridData(midRangeStarDrillData, 4);
    let gridData5 = preProcessGridData(sideMidSideDrillData, 5);
    let gridData6 = preProcessGridData(midSideMidDrillData, 6);
    let gridData7 = preProcessGridData(offTheDribbleShootingData, 7);
    let gridData8 = preProcessGridData(freeThrowsData, 8);

    return [
      gridData1,
      gridData2,
      gridData3,
      gridData4,
      gridData5,
      gridData6,
      gridData7,
      gridData8,
    ];
  };

  const downloadExcel = () => {
    let playerProfileExcelData = exportPlayerProfileDataToExcel(
      playerData,
      lengthUnits,
      weightUnits,
      getWeightUnitValue,
      getLengthUnitValue,
      getWeightUnitLabelType
    );

    let playerCareerStatsExcelData = exportPlayerCareerStatsToExcel(
      playerCareerStatsData
    );

    let anthrosSummaryExcelData = exportAnthrosSummaryDataToExcel(
      anthrosSummaryData,
      getLengthUnitLabelType,
      getLengthUnitValue,
      getWeightUnitLabelType,
      getWeightUnitValue,
      lengthUnits,
      weightUnits,
      getHandDimensionsUnitValue,
      getHandDimensionsUnitLabelType,
      selectedEvent
    );

    let strengthAndAgilityExcelData = exportStrengthAndAgilityDataToExcel(
      strengthAndAgilityData,
      lengthUnits,
      getHandDimensionsUnitValue,
      getHandDimensionsUnitLabelType,
      selectedEvent
    );

    // Shooting Drills Data
    let gridData1 = preProcessGridData(shootingDrillsOverallSummary, 1);
    let gridData2 = preProcessGridData(spotUpDrillData, 2);
    let gridData3 = preProcessGridData(threePointStarDrillData, 3);
    let gridData4 = preProcessGridData(midRangeStarDrillData, 4);
    let gridData5 = preProcessGridData(sideMidSideDrillData, 5);
    let gridData6 = preProcessGridData(midSideMidDrillData, 6);
    let gridData7 = preProcessGridData(offTheDribbleShootingData, 7);
    let gridData8 = preProcessGridData(freeThrowsData, 8);

    let shootingDrillsExcelData = exportShootingDrillsDataToExcel([
      gridData1,
      gridData2,
      gridData3,
      gridData4,
      gridData5,
      gridData6,
      gridData7,
      gridData8,
    ]);

    setSheetData([
      {
        key: Math.trunc(Math.random() * 100),
        sheetName: "Player Profile",
        dataset:
          playerProfileExcelData && playerProfileExcelData.length > 0
            ? playerProfileExcelData
            : blankDataset,
      },
      {
        key: Math.trunc(Math.random() * 100),
        sheetName: "Player Career Stats",
        dataset:
          playerCareerStatsExcelData && playerCareerStatsExcelData.length > 0
            ? playerCareerStatsExcelData
            : blankDataset,
      },
      {
        key: Math.trunc(Math.random() * 100),
        sheetName: "Anthropometry",
        dataset:
          anthrosSummaryExcelData && anthrosSummaryExcelData.length > 0
            ? anthrosSummaryExcelData
            : blankDataset,
      },
      {
        key: Math.trunc(Math.random() * 100),
        sheetName: "Strength+Agility",
        dataset:
          strengthAndAgilityExcelData && strengthAndAgilityExcelData.length > 0
            ? strengthAndAgilityExcelData
            : blankDataset,
      },
      {
        key: Math.trunc(Math.random() * 100),
        sheetName: "Shooting Drills",
        dataset:
          shootingDrillsExcelData && shootingDrillsExcelData.length > 0
            ? shootingDrillsExcelData
            : blankDataset,
      },
    ]);
    setExcelClick(true);
  };

  return (
    <Box>
      {/* <ExcelFile
        filename={`View Player Profile`}
        element={
          <IconButton id="view-player-profile-excel-export"></IconButton>
        }
      >
        <ExcelSheet
          data={sheetData}
          dataSet={sheetData[0].dataset}
          name={sheetData[0].sheetName}
          key={sheetData[0].key}
        />
        <ExcelSheet
          data={sheetData}
          dataSet={sheetData[1].dataset}
          name={sheetData[1].sheetName}
          key={sheetData[1].key}
        />
        <ExcelSheet
          data={sheetData}
          dataSet={sheetData[2].dataset}
          name={sheetData[2].sheetName}
          key={sheetData[2].key}
        />
        <ExcelSheet
          data={sheetData}
          dataSet={sheetData[3].dataset}
          name={sheetData[3].sheetName}
          key={sheetData[3].key}
        />
        <ExcelSheet
          data={sheetData}
          dataSet={sheetData[4].dataset}
          name={sheetData[4].sheetName}
          key={sheetData[4].key}
        />
      </ExcelFile> */}
      <Button
        size="small"
        className={classes.exportToExcel}
        title="Export to Excel"
        sx={{
          border: "1px solid lightgrey",
          boxShadow: "1px 1px 3px black",
          minWidth: "auto !important",
        }}
        onClick={exportToExcelHandler}
      >
        <img
          alt="pngImg"
          src="../../../../playerProfile/excel.png"
          width="26"
          height="26"
        />
      </Button>
    </Box>
  );
}
